import { render } from "./produtoForm.vue?vue&type=template&id=33d2723c&scoped=true"
import script from "./produtoForm.vue?vue&type=script&lang=js"
export * from "./produtoForm.vue?vue&type=script&lang=js"

import "./produtoForm.vue?vue&type=style&index=0&id=33d2723c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d2723c"]])

export default __exports__